import React from 'react';
import { Col, Button } from 'react-bootstrap';

const OperationButtons = ({ loading, onRoscon, onRoscof, onTampaAbrir, onTampaFechar, disabled = false }) => {
  return (
    <>
      <Col xs={12} sm={6} md={4} lg={3}>
        <Button
          className="w-100 py-2 mb-2"
          disabled={loading || disabled}
          onClick={onRoscon}
          style={{
            fontWeight: 500,
            letterSpacing: 0.5,
            fontSize: '0.85rem',
            whiteSpace: 'pre-line',
            minHeight: '50px',
            position: 'relative',
            backgroundColor: 'var(--success-color, #198754)',
            color: '#fff',
            border: 'none'
          }}
        >
          ▶️ Ligar Dosador
        </Button>
      </Col>
      <Col xs={12} sm={6} md={4} lg={3}>
        <Button
          className="w-100 py-2 mb-2"
          disabled={loading || disabled}
          onClick={onRoscof}
          style={{
            fontWeight: 500,
            letterSpacing: 0.5,
            fontSize: '0.85rem',
            whiteSpace: 'pre-line',
            minHeight: '50px',
            position: 'relative',
            backgroundColor: 'var(--danger-color, #dc3545)',
            color: '#fff',
            border: 'none'
          }}
        >
          ⏹️ Desligar Dosador
        </Button>
      </Col>
      <Col xs={12} sm={6} md={4} lg={3}>
        <Button
          className="w-100 py-2 mb-2"
          disabled={loading || disabled}
          onClick={onTampaAbrir}
          style={{
            fontWeight: 500,
            letterSpacing: 0.5,
            fontSize: '0.85rem',
            whiteSpace: 'pre-line',
            minHeight: '50px',
            position: 'relative',
            backgroundColor: 'var(--info-color, #0dcaf0)',
            color: '#fff',
            border: 'none'
          }}
        >
          🔓 Abrir Tampa
        </Button>
      </Col>
      <Col xs={12} sm={6} md={4} lg={3}>
        <Button
          className="w-100 py-2 mb-2"
          disabled={loading || disabled}
          onClick={onTampaFechar}
          style={{
            fontWeight: 500,
            letterSpacing: 0.5,
            fontSize: '0.85rem',
            whiteSpace: 'pre-line',
            minHeight: '50px',
            position: 'relative',
            backgroundColor: 'var(--warning-color, #ffc107)',
            color: '#212529',
            border: 'none'
          }}
        >
          🔒 Fechar Tampa
        </Button>
      </Col>
    </>
  );
};

export default OperationButtons;
